import type { Vehicle } from "../Interfaces/vehicle.type";
import {
  invoiceNotPaid,
  invoicePaid,
  partnerFinance,
} from "./TransportModalSundryScenarios";

interface ITransportModalSundryMessages {
  vehicle: Vehicle;
  sectionType: string;
  openInvoiceModal?: () => void;
}

export interface ISundryMessages {
  deliveryAlert: string | null;
  collectionsAlert: string | null;
  collectionsCta: string;
  collectionsLink: string | null;
  collectionsAction: () => void | null;
}

export default function TransportModalSundryMessages({
  vehicle,
  sectionType,
  openInvoiceModal,
}: ITransportModalSundryMessages): ISundryMessages {
  if (invoiceNotPaid.acceptableValues.includes(sectionType)) {
    return { ...invoiceNotPaid, collectionsAction: openInvoiceModal };
  }

  if (invoicePaid.acceptableValues.includes(sectionType)) {
    return {
      ...invoicePaid,
      deliveryAlert: vehicle.delivery.isSundry
        ? invoicePaid.deliveryAlert
        : null,
    };
  }

  if (partnerFinance.acceptableValues.includes(sectionType)) {
    return {
      ...partnerFinance,
      deliveryAlert: vehicle.delivery.isSundry
        ? partnerFinance.deliveryAlert
        : null,
    };
  }
}
